module.exports = __webpack_public_path__ + "static/government-seating-94a823ecaa42ac3bda4950c763732fb4.jpg";